import WebsiteEntertainmentModel from '@models/website/WebsiteEntertainmentModel';
import EventTypeModel            from '@models/website/EventTypeModel';
import EventStatusModel          from '@models/website/EventStatusModel';
import EventDisplayModeModel     from '@models/website/EventDisplayModeModel';
import PlaceModel                from '@models/website/PlaceModel';
import EventWorkflowModel        from '@models/website/EventWorkflowModel';
import doc                       from '@widesk-core/decorators/doc';
import WebsiteServiceModel       from '@/models/WebsiteServiceModel';
import Blamable                  from '@/models/traits/Blamable';
import { Addable }               from '@widesk-core/decorators/addable';
import { Editable }              from '@widesk-core/decorators/editable';
import { Deletable }             from '@widesk-core/decorators/deletable';
import { Timestampable }         from '@widesk-core/decorators/timestampable';

@doc.path('/events/{?id}')
@doc.addable
@doc.editable
@doc.deletable
@doc.timestampable
abstract class AbstractEventModel extends Blamable(WebsiteServiceModel) {
	declare protected _tsFilters: {
		'partial': string;
		'existsInContentToPublish': string;
		'paid': string;
		'private': string;
		'hourIsFinal': string;
		'dayIsFinal': string;
		'syncToDedication': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'date[before]': id;
		'date[strictly_before]': id;
		'date[after]': id;
		'date[strictly_after]': id;
		'start[before]': id;
		'start[strictly_before]': id;
		'start[after]': id;
		'start[strictly_after]': id;
		'end[before]': id;
		'end[strictly_before]': id;
		'end[after]': id;
		'end[strictly_after]': id;
		'exists[eventRequiredObjects]': string;
		'exists[place]': string;
		'completionPercent[between]': id;
		'completionPercent[gt]': id;
		'completionPercent[gte]': id;
		'completionPercent[lt]': id;
		'completionPercent[lte]': id;
		'websiteEntertainment': id;
		'websiteEntertainment.website': id;
		'date': string | Date;
		'eventType': id;
		'eventStatus': string;
		'eventDisplayMode': string;
		'slug': id;
		'place': id;
		'programmingWorkflow': id;
		'communicationWorkflow': id;
		'planificationWorkflow': id;
		'eventParticipations.participation': id;
		'eventPartnerships.partnership': id;
		'eventTaxonomies.taxonomy': id;
		'eventTaxonomies.position': string;
		'eventTags.tag': id;
		'eventUserGroups.userGroup': id;
		'search': string;
	};

	declare private _tsSorts: {
		'daisukiCount': string;
		'id': string;
		'date': string;
		'start': string;
		'end': string;
		'createdAt': string;
		'updatedAt': string;
		'completionPercent': string;
		'translations.title': string;
	};

	@doc.model(WebsiteEntertainmentModel)
	declare websiteEntertainment: WebsiteEntertainmentModel;
	@doc.model(EventTypeModel) declare eventType: EventTypeModel;
	@doc.model(EventStatusModel) declare eventStatus: EventStatusModel;
	@doc.model(EventDisplayModeModel)
	declare eventDisplayMode: EventDisplayModeModel;
	@doc.string declare slug: string;
	@doc.date declare date: Dayjs;
	@doc.date declare start: Dayjs;
	@doc.date declare end: Dayjs;
	@doc.boolean declare paid: boolean;
	@doc.model(PlaceModel) declare place: PlaceModel;
	@doc.boolean declare private: boolean;
	@doc.boolean declare hourIsFinal: boolean;
	@doc.boolean declare dayIsFinal: boolean;
	@doc.number declare completionPercent: number;
	@doc.boolean declare syncToDedication: boolean;
	@doc.model(EventWorkflowModel)
	declare programmingWorkflow: EventWorkflowModel;
	@doc.model(EventWorkflowModel)
	declare communicationWorkflow: EventWorkflowModel;
	@doc.model(EventWorkflowModel)
	declare planificationWorkflow: EventWorkflowModel;
}

interface AbstractEventModel
	extends Addable,
		Editable,
		Deletable,
		Timestampable {}

export default AbstractEventModel;
